import React, { useState, useEffect, useRef } from 'react';

/**
 * COMPONENTE: KARAOKE SCREEN (OVERLAY MODE)
 * ------------------------------------------------------------------
 * Diseñado para funcionar como una capa transparente sobre video (OBS).
 * Muestra una barra superior con la letra sincronizada.
 * ------------------------------------------------------------------
 */
const Karaoke = ({ data }) => {

    // --- ESTADOS ---
    const [currentLine, setCurrentLine] = useState(null);       // Objeto con la línea actual { text, mode, duration }
    const [isVisible, setIsVisible] = useState(true);           // Control maestro de visibilidad
    const [isFillingEnabled, setIsFillingEnabled] = useState(true); // Activar/Desactivar animación
    
    // Configuración de colores (Valores por defecto)
    const [colors, setColors] = useState({ base: '#ffffff', fill: '#ffd400', stroke: '#000000' });

    // --- REFERENCIAS (Para manipulación directa del DOM en animaciones) ---
    const transitionRef = useRef(null); // Referencia al div que se rellena (Capa Fill)

    // -------------------------------------------------------------------------
    // 1. GESTIÓN DEL BODY (Fondo Transparente)
    // -------------------------------------------------------------------------
    useEffect(() => {
        // Agregamos la clase al body para asegurar fondo transparente en OBS
        document.body.classList.add('Karaoke__Screen__Body');
        
        return () => {
            document.body.classList.remove('Karaoke__Screen__Body');
        }
    }, []);

    // -------------------------------------------------------------------------
    // 2. ESCUCHA DE DATOS (WEBSOCKET)
    // -------------------------------------------------------------------------
    useEffect(() => {
        if (!data) return;

        // Desestructuramos la acción y el resto del payload
        const { action, ...payload } = data;

        switch (action) {
            case 'show_lyric':
                animateLyric(payload); // Iniciamos secuencia de animación
                break;
            case 'set_colors':
                setColors({ base: payload.baseColor, fill: payload.fillColor, stroke: payload.strokeColor });
                break;
            case 'set_visible':
                setIsVisible(payload.value);
                break;
            case 'set_fill':
                setIsFillingEnabled(payload.value);
                break;
            default:
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    // -------------------------------------------------------------------------
    // 3. LÓGICA DE ANIMACIÓN (Core)
    // -------------------------------------------------------------------------
    const animateLyric = (lyricData) => {
        // A) Reseteo Inmediato:
        // Quitamos la transición para que el ancho regrese a 0% instantáneamente sin animar el retroceso
        if (transitionRef.current) {
            transitionRef.current.style.transition = 'none';
            transitionRef.current.style.width = '0%';
        }
        
        // Actualizamos el texto
        setCurrentLine(lyricData);

        // Si es instrumental, terminamos aquí (se muestra el texto/ícono pero no se rellena)
        if (lyricData.mode === 'instrumental') return;

        // B) Inicio de Animación:
        if (isFillingEnabled) {
            // Usamos un pequeño Timeout (50ms) para dar tiempo al navegador de renderizar el width: 0%
            setTimeout(() => {
                if (transitionRef.current) {
                    // 1. Definimos la duración exacta que viene del backend (lineal para karaoke)
                    transitionRef.current.style.transition = `width ${lyricData.duration}ms linear`;
                    // 2. Disparamos el cambio de ancho al 100%
                    transitionRef.current.style.width = '100%';
                }
            }, 50);
        }
    };

    // -------------------------------------------------------------------------
    // 4. RENDERIZADO
    // -------------------------------------------------------------------------
    
    // Si el admin oculta la letra o no hay línea, no renderizamos nada (transparencia total)
    if (!isVisible || !currentLine) return <div className='Karaoke__Screen' />;

    return (
        <div className='Karaoke__Screen'>
            {/* Contenedor de la barra superior */}
            <div className='Karaoke__Screen__BarUp' style={{ flexDirection: 'column' }}>
                
                {/* Contenedor relativo para apilar las capas de texto */}
                <div className='Karaoke__Screen__Line'>
                    
                    {/* CAPA 1: TEXTO BASE (Color inactivo + Borde) */}
                    <div className='Karaoke__Screen__Text Karaoke__Screen__Text--Base' style={{ color: colors.base, WebkitTextStroke: `2px ${colors.stroke}` }}>{currentLine.text}</div>

                    {/* CAPA 2: TEXTO RELLENO (Color activo + Borde + Animación) */}
                    {/* Solo se renderiza si no es instrumental */}
                    {currentLine.mode !== 'instrumental' && (
                        <div className='Karaoke__Screen__Text Karaoke__Screen__Text--Fill' ref={transitionRef} style={{ color: colors.fill, WebkitTextStroke: `2px ${colors.stroke}` }}>{currentLine.text}</div>
                    )}
                </div>

                {currentLine.mode !== 'instrumental' && (
                    <p className='Karaoke__Screen__Credits'>Powered by Interaktia</p>
                )}
            </div>
        </div>
    );
};

export { Karaoke };












// import { useEffect } from 'react'


// const Karaoke = () => {

//     const LoadPage = () => {
//         try {
            
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         document.body.classList.add('Karaoke__Screen__Body')
        
//         return () => {
//             document.body.classList.remove('Karaoke__Screen__Body')
//         }
//     },[])
    

//     return (
//         <div className='Karaoke__Screen'></div>
//     )
// }

// export { Karaoke };









//import React, { useState, useEffect, useRef } from 'react'

// const Karaoke = ({ data, isActiveWomensMode }) => {
//     // -------------------------------------------------------------------------
//     // 1. ESTADOS VISUALES
//     // -------------------------------------------------------------------------
//     const [currentLine, setCurrentLine] = useState(null); // { text, mode, duration }
//     const [isVisible, setIsVisible] = useState(true);
//     const [isFillingEnabled, setIsFillingEnabled] = useState(true);

//     const [colors, setColors] = useState({
//         base: '#ffffff',
//         fill: '#ffd400',
//         stroke: '#000000'
//     });

//     // Control de animación (0% a 100%)
//     const [fillProgress, setFillProgress] = useState(0);

//     // Referencias para manipular la transición CSS directamente
//     const transitionRef = useRef(null);

//     // -------------------------------------------------------------------------
//     // 2. CONFIGURACIÓN INICIAL (Body Class)
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete");
//         } catch (error) { }
//     }, []);

//     // -------------------------------------------------------------------------
//     // 3. ESCUCHA DE DATOS (WEBSOCKET)
//     // Cada vez que 'Screen.js' recibe algo, actualiza la prop 'data'
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         if (!data) return;

//         const { action, ...payload } = data;

//         switch (action) {
//             case 'show_lyric':
//                 handleNewLyric(payload);
//                 break;
//             case 'set_colors':
//                 setColors({
//                     base: payload.baseColor,
//                     fill: payload.fillColor,
//                     stroke: payload.strokeColor
//                 });
//                 break;
//             case 'set_visible':
//                 setIsVisible(payload.value);
//                 break;
//             case 'set_fill':
//                 setIsFillingEnabled(payload.value);
//                 break;
//             default:
//                 break;
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [data]); // Se dispara cada vez que llega un mensaje nuevo desde el Admin

//     // -------------------------------------------------------------------------
//     // 4. LÓGICA DE ANIMACIÓN
//     // -------------------------------------------------------------------------
//     const handleNewLyric = (lyricData) => {
//         // 1. Reset inmediato (sin transición) para preparar la nueva línea
//         if (transitionRef.current) {
//             transitionRef.current.style.transition = 'none';
//         }
//         setFillProgress(0);
//         setCurrentLine(lyricData);

//         // Si es instrumental, solo mostramos el texto (o ícono) sin rellenar
//         if (lyricData.mode === 'instrumental') return;

//         // 2. Iniciar animación
//         if (isFillingEnabled) {
//             // Pequeño timeout para permitir que el DOM pinte el width: 0% primero
//             setTimeout(() => {
//                 if (transitionRef.current) {
//                     // Aplicamos la duración exacta que viene del backend
//                     transitionRef.current.style.transition = `width ${lyricData.duration}ms linear`;
//                     // Disparamos el llenado
//                     setFillProgress(100);
//                 }
//             }, 50);
//         }
//     };

//     // -------------------------------------------------------------------------
//     // 5. RENDERIZADO
//     // -------------------------------------------------------------------------
//     return (
//         <>
//             {/* --- FONDO (Mantenemos tu lógica original) --- */}
//             <div className='SelfieFan__Screen__QR__Background'>
//                 {isActiveWomensMode ? (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo Femenil" />
//                 ) : isActiveWomensMode === false && (
//                     <img src='/img/page/backgrounds/background.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo Varonil" />
//                 )}
//             </div>

//             {/* --- CONTENEDOR DE LETRA (Sobrepuesto) --- */}
//             {/* Usamos una estructura flex centrada que ocupa toda la pantalla */}
//             <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 display: isVisible ? 'flex' : 'none', // Ocultar si el admin lo pide
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 zIndex: 10, // Encima del fondo
//                 padding: '0 5%' // Margen lateral seguro
//             }}>
//                 {currentLine && (
//                     <div style={{
//                         position: 'relative',
//                         textAlign: 'center',
//                         fontFamily: 'system-ui, -apple-system, sans-serif',
//                         fontWeight: '900',
//                         lineHeight: 1.1,
//                         // Tamaño de fuente responsivo gigante
//                         fontSize: 'clamp(50px, 7vw, 130px)' 
//                     }}>
                        
//                         {/* CAPA 1: TEXTO BASE (Borde y Color Base) */}
//                         <div style={{
//                             color: colors.base,
//                             // Compatibilidad con stroke en navegadores
//                             WebkitTextStroke: `3px ${colors.stroke}`,
//                             position: 'relative',
//                             zIndex: 1
//                         }}>
//                             {currentLine.text}
//                         </div>

//                         {/* CAPA 2: RELLENO ANIMADO (Solo si no es instrumental) */}
//                         {currentLine.mode !== 'instrumental' && (
//                             <div
//                                 ref={transitionRef}
//                                 style={{
//                                     position: 'absolute',
//                                     top: 0,
//                                     left: 0,
//                                     // El color de relleno
//                                     color: colors.fill,
//                                     WebkitTextStroke: `3px ${colors.stroke}`,
                                    
//                                     // La magia del recorte
//                                     width: `${fillProgress}%`,
//                                     overflow: 'hidden',
//                                     whiteSpace: 'nowrap',
//                                     zIndex: 2,
                                    
//                                     // Nota: La transición se define dinámicamente en JS
//                                 }}
//                             >
//                                 {currentLine.text}
//                             </div>
//                         )}
//                     </div>
//                 )}
//             </div>

//             {/* --- FOOTER (Mantenemos tu lógica original) --- */}
//             <footer className='SelfieFan__Screen__QR__Footer FooterCredits' style={{ zIndex: 20 }}>
//                 Hecho con ♥ | 2026
//             </footer>
//         </>
//     );
// };

// export { Karaoke };









// import { useEffect } from 'react'


// const Karaoke = ({ data, isActiveWomensMode }) => {

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     }, [])
    

//     return (
//         <>
//             <div className='SelfieFan__Screen__QR__Background'>
//                 {isActiveWomensMode ? (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 ) : isActiveWomensMode === false && (
//                     <img src='/img/page/backgrounds/background.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 )}
//             </div>

//             <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'>
//                 <p>Karaoke</p>
//             </div>

//             <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ | 2026</footer>
//         </>
//     )
// }

// export { Karaoke };